// Human-readable durations <-> seconds. The API only ever sees seconds.
const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

export const DURATION_UNITS = [
  { value: "minutes", label: "Minutes", seconds: MINUTE },
  { value: "hours", label: "Hours", seconds: HOUR },
  { value: "days", label: "Days", seconds: DAY },
  { value: "weeks", label: "Weeks", seconds: WEEK },
  { value: "months", label: "Months", seconds: MONTH },
  { value: "years", label: "Years", seconds: YEAR },
];

const unitSeconds = (unit) =>
  DURATION_UNITS.find((u) => u.value === unit)?.seconds || HOUR;

// 2 + "hours" -> 7200. Returns null for empty/invalid input.
export const toSeconds = (value, unit) => {
  const n = Number(value);
  if (value === "" || value === null || value === undefined) return null;
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n * unitSeconds(unit));
};

// 7200 -> { value: 2, unit: "hours" } using the largest unit that divides evenly.
export const fromSeconds = (seconds) => {
  const s = Number(seconds);
  if (!Number.isFinite(s) || s <= 0) return { value: "", unit: "hours" };
  const unit = [...DURATION_UNITS]
    .reverse()
    .find((u) => s % u.seconds === 0);
  if (!unit) return { value: Math.round(s / MINUTE), unit: "minutes" };
  return { value: s / unit.seconds, unit: unit.value };
};

// 7200 -> "2h", 273600 -> "3d 4h", 15552000 -> "6 mo"
export const formatDuration = (seconds) => {
  let s = Math.round(Number(seconds));
  if (!Number.isFinite(s) || s <= 0) return "—";
  const parts = [];
  const take = (size, suffix) => {
    const n = Math.floor(s / size);
    if (n > 0) {
      parts.push(`${n}${suffix}`);
      s -= n * size;
    }
  };
  take(YEAR, "y");
  take(MONTH, " mo");
  take(DAY, "d");
  take(HOUR, "h");
  take(MINUTE, "m");
  // keep it short: the two most significant units
  return parts.slice(0, 2).join(" ") || "<1m";
};

// ISO timestamp -> "2026-10-12 15:00" (local time)
export const formatReadyAt = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(
    d.getHours()
  )}:${p(d.getMinutes())}`;
};
